<template>
  <!-- Watch video modal template -->
  <b-modal ref="watch-video" hide-footer @hide="hideGuideModal" size="xl">
    <div class="d-block text-center">
      <h3 qid="guide-watch-video-title" class="mb-2">
        {{ $t('administration.guide.modal.video_title') }}
      </h3>
    </div>

    <div class="mt-4"  style="font-size: 18px;" v-if="guide && guide.id">

      <b-tabs class="mt-3" v-if="guide.media && guide.media.length">

        <!-- First tab -->
        <b-tab :title="media.name" v-for="media in guide.media">
          <div class="mt-3">
            <video controls :src="media.url" style="width: 100%;"></video>
          </div>
        </b-tab>

      </b-tabs>

    </div>

    <b-button class="mt-4 float-right"
              variant="secondary"
              @click="closeModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'GuideWatchVideoModal',
    data: function() {
      return {
        error: '',
        showCheckbox: false,
        doNotShowGuide: 0
      }
    },
    props: {
      guide: {},
      showModal: {
        type: Boolean
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showGuideModal()
        }
      }
    },
    methods: {
      showGuideModal() {
        let self = this
        this.$refs['watch-video'].show()
      },
      hideGuideModal() {
        let self = this;
        this.error = ''
        this.$emit('closeWatchVideoModal');
        this.$refs['watch-video'].hide()
      },
      closeModal() {
        this.$refs['watch-video'].hide()
      }
    },
    created () {

    }
  }
</script>
